import { useState } from 'react';

const useDrip = (initialValue = false, ref) => {
  const [dripVisible, setDripVisible] = useState(initialValue);
  const [dripX, setDripX] = useState(0);
  const [dripY, setDripY] = useState(0);

  const dripCompletedHandle = () => {
    setDripVisible(false);
    setDripX(0);
    setDripY(0);
  };

  const clickHandler = event => {
    if (!ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    setDripVisible(true);
    setDripX(event.clientX - rect.left);
    setDripY(event.clientY - rect.top);
  };

  return {
    visible: dripVisible,
    x: dripX,
    y: dripY,
    onClick: clickHandler,
    onCompleted: dripCompletedHandle
  };
};

export default useDrip;